<template>
  <component
    v-if="validProperties"
    :is="fieldComponent"
    v-model="localValue"
    v-bind="properties"
  />
</template>

<script>
import TextInput from "@/components/form-elements/elements/TextInput.vue";
import SelectInput from "@/components/form-elements/elements/SelectInput.vue";
import CheckboxInput from "@/components/form-elements/elements/CheckboxInput.vue";
import RadioButtonGroupInput from "@/components/form-elements/elements/RadioButtonGroupInput.vue";
import TextAreaInput from "@/components/form-elements/elements/TextAreaInput.vue";
import DateInput from "@/components/form-elements/elements/DateInput.vue";
import TimeInput from "@/components/form-elements/elements/TimeInput.vue";
import NumberInput from "@/components/form-elements/elements/NumberInput.vue";
import MultiSelect from "@/components/form-elements/search-components/MultiSelect.vue";
import DateRange from "@/components/form-elements/search-components/DateRange.vue";
import TimeRange from "@/components/form-elements/search-components/TimeRange.vue";
import NumberRange from "@/components/form-elements/search-components/NumberRange.vue";

const componentMap = {
  text: TextInput,
  date: DateInput,
  daterange: DateRange,
  time: TimeInput,
  timerange: TimeRange,
  number: NumberInput,
  numberrange: NumberRange,
  textarea: TextAreaInput,
  select: SelectInput,
  multiselect: MultiSelect,
  checkbox: CheckboxInput,
  radio: RadioButtonGroupInput
};

export default {
  props: {
    properties: {
      type: Object,
      required: true
    },
    value: {
      required: true
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit("input", localValue);
      }
    },
    fieldComponent() {
      return componentMap[this.properties.fieldType];
    },
    validProperties() {
      return (
        !this.isNullorUndefined(this.properties) &&
        !this.isNullorUndefined(this.properties["fieldType"]) &&
        !this.isNullorUndefined(this.fieldComponent)
      );
    }
  },
  methods: {
    isNullorUndefined(val) {
      return val == null || val == undefined;
    }
  }
};
</script>

<style lang="scss" scoped></style>
